import {Box} from '@mui/material';
import {useQueryClient} from 'react-query';
import {useDispatch} from 'react-redux';
import CustomisedCardBullet from '../../../../../components/card/cardBullet';
import ElementTitle from '../../../../../components/title/elementTitle/elementTitle';
import {useAppBar} from '../../../../../components/appBar/appBarContext';
import {useEffect} from 'react';
import {setHeaderTitle} from '../../../../../redux/headerTitle/headerTitleSlice';
import {
    changeRouteType,
    getpervInnerState,
} from '../../../../../redux/handleBackBtn/handleBackBtnSlice';

const CanceledLoans = () => {
    const queryClient = useQueryClient();
    const dispatch = useDispatch();
    const randomKeyForDispatch = Math.random();
    const {setHeader} = useAppBar();
    const data = queryClient.getQueryData<{
        cancellationReasons: string[];
        cancelDescription: string;
    }>('CANCLE_REASONS');
    const cancellationReasons = data?.cancellationReasons;
    const cancelDescription = data?.cancelDescription;
    setHeader('لغو شده توسط کارشناس', 'loans');

    return (
        <div className="container-height-drawer">
            <div className=" primaryColorLight-900 content-container">
                <div className="drawer-content">
                    <ElementTitle
                        title={
                            'این تسهیلات به دلایل زیر توسط کارشناس لغو شده است:'
                        }
                    />
                    {cancelDescription && (
                        <CustomisedCardBullet
                            firstTitle={cancelDescription}
                            bulletColor="#FF617C !important"
                        />
                    )}
                    {cancellationReasons?.map(
                        (reason: string, index: number) => (
                            <Box sx={{width: '100%'}}>
                                <CustomisedCardBullet
                                    firstTitle={reason}
                                    key={index}
                                    bulletColor="#FF617C !important"
                                />
                            </Box>
                        )
                    )}
                </div>
            </div>
        </div>
    );
};

export default CanceledLoans;
